import { Box, Modal, Fade, Grid, Typography, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ScreenLoader from "../shared/ScreenLoader";
import { calculateLeftDays } from "../../utils/helperFunctions";

const style = {
  position: "absolute",
  top: "20px",
  height: "calc(100vh - 40px)",
  width: "calc(100vw - 50%)",
  marginRight: "20%",
  marginLeft: "20%",
  bgcolor: "#F8FAFB",
  border: "none",
};

/**
 * @param {Array} licenses
 * @param {Boolean} loading
 * @param {Object} handleClose close modal handler
 * @returns
 */
const ViewHistoryModal = ({ licenses, loading, handleClose }) => {
  return (
    <Modal
      aria-labelledby="license-history"
      aria-describedby="license-history"
      open={true}
      onClose={handleClose}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      sx={{ zIndex: 10000 }}
    >
      <Fade in={true}>
        <Box sx={style}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              height: "64px",
              p: "15px",
              backgroundColor: "#050D2E",
            }}
          >
            <Grid item>
              <Typography
                sx={{ color: "#ffffff", fontSize: "1.25rem", fontWeight: 550 }}
              >
                License History
              </Typography>
            </Grid>
            <Grid item>
              <CloseIcon
                sx={{ color: "#ffffff", cursor: "pointer" }}
                onClick={handleClose}
              />
            </Grid>
          </Grid>
          {loading ? (
            <ScreenLoader />
          ) : (
            <Box
              sx={{
                height: "calc(100vh - 110px)",
                width: "100%",
                overflowY: "scroll",
              }}
            >
              <Grid
                container
                direction="column"
                sx={{
                  p: "20px",
                }}
              >
                {licenses.map((license) => (
                  <Grid
                    key={license.key}
                    item
                    container
                    direction="column"
                    sx={{
                      backgroundColor:
                        license.status === "RUNNING" ? "#FFFFFF" : "#F2F4F8",
                      p: 2,
                      my: 1,
                      border: "1px solid #E7E9EF",
                      borderRadius: "6px",
                    }}
                  >
                    <Grid item container justifyContent="flex-end">
                      <Chip
                        label={
                          license.status === "EXPIRED" ? "Expired" : "Active"
                        }
                        sx={{
                          height: "20px",
                          backgroundColor:
                            license.status === "EXPIRED"
                              ? "#FFD8D6"
                              : "#E5F6E4",
                          color:
                            license.status === "EXPIRED"
                              ? "#400F0C"
                              : "#002B00",
                        }}
                      />
                    </Grid>
                    {/*Name */}
                    <Grid item container>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                          }}
                        >
                          Licensed to:
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            fontWeight: 550,
                            lineHeight: "21px",
                          }}
                        >
                          {license.bankName} {license.bankBic}
                        </Typography>
                      </Grid>
                    </Grid>
                    {/*Key */}
                    <Grid item container>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                          }}
                        >
                          Licensed Key:
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            fontWeight: 550,
                            lineHeight: "21px",
                          }}
                        >
                          {license.keySimplified}
                        </Typography>
                      </Grid>
                    </Grid>
                    {/*Users */}
                    <Grid item container>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                          }}
                        >
                          Users:
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            fontWeight: 550,
                            lineHeight: "21px",
                          }}
                        >
                          {license.allowedUsers}
                        </Typography>
                      </Grid>
                    </Grid>
                    {/*Messages */}
                    <Grid item container>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                          }}
                        >
                          Messages/Day:
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            fontWeight: 550,
                            lineHeight: "21px",
                          }}
                        >
                          {license.messages}
                        </Typography>
                      </Grid>
                    </Grid>
                    {/*Renewal */}
                    <Grid item container>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                          }}
                        >
                          {license.status === "RUNNING"
                            ? "License Renewal:"
                            : "Expiration Date:"}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          sx={{
                            color: "#050D2E",
                            fontSize: ".875rem",
                            lineHeight: "21px",
                            fontWeight: 550,
                          }}
                        >
                          {`${new Date(license.expiryDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )} 
                    `}
                          {license.status === "RUNNING"
                            ? `(${calculateLeftDays(
                                new Date(license?.creationDate),
                                new Date(license?.expiryDate)
                              )} Days)`
                            : null}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ViewHistoryModal;
